"use strict";
// Smart Mode copy shared by the web Debt Eliminator and the mobile screen
// (BEN-141 P5, tracker row PH1-037, assumption `smart-mode`).
//
// WHY IT IS SHARED, AND WHY IT IS ONLY THE LABEL. The recommendation itself, its
// two thresholds and the sentence explaining it are all computed server-side and
// arrive on `summary.recommendation`; both clients render `reason` verbatim
// rather than rebuilding it, so there is nothing to keep in step there. What the
// two screens do own is the word on the badge, and a badge reading "Recommended"
// on one platform and "Suggested" or "Best for you" on the other is exactly the
// drift #781 is about. One constant removes the question.
//
// The badge is a word, not a colour: the recommended strategy has to be
// identifiable to someone who cannot distinguish the accent from the default.
Object.defineProperty(exports, "__esModule", { value: true });
exports.RECOMMENDED_BADGE_LABEL = void 0;
exports.recommendedBadgeAccessibilityLabel = recommendedBadgeAccessibilityLabel;
/** The badge on the strategy Smart Mode picked. */
exports.RECOMMENDED_BADGE_LABEL = "Recommended";
/**
 * Spoken form for assistive technology, used where the badge sits beside a
 * control whose own label does not repeat the strategy name.
 */
function recommendedBadgeAccessibilityLabel(strategyLabel) {
    return `${strategyLabel}, recommended`;
}
//# sourceMappingURL=strategyRecommendation.js.map